import UserPagingResultModelBase from '../_generated/modelBases/user-paging-result-model-base';

export default class UserPagingResultModel extends UserPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
